import { CSSProperties } from 'react'

import { SxProps, Theme } from '@mui/material'

export const frameStyles: CSSProperties = {
  width: '100%',
  border: 'none',
  overflow: 'hidden',
}

export const editorDescriptionRootContainerSx = ({
  isContentLoaded,
}: {
  isContentLoaded: boolean
}): SxProps<Theme> => {
  return {
    height: isContentLoaded ? 'auto' : '100%',
    justifyContent: 'center',
  }
}

export const loadingWrapperSx = ({
  isContentLoaded,
}: {
  isContentLoaded: boolean
}): SxProps<Theme> => {
  return {
    display: !isContentLoaded ? 'flex' : 'none',
    justifyContent: 'center',
    alignSelf: 'center',
  }
}
